import { render, staticRenderFns } from "./pii-element.vue?vue&type=template&id=5c709284"
import script from "./pii-element.vue?vue&type=script&lang=js"
export * from "./pii-element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports